export const isSameCustomer = (customer, customerNumber) =>
	!!customer && String(customer.customerNumber) === String(customerNumber)
